/* unplugin-vue-components disabled */import { render } from "./LoginBox.vue?vue&type=template&id=1fd46ed7&lang=pug"
import script from "./LoginBox.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginBox.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__